// Link della confezione regalo
const GIFT_PRODUCT_URL = '/products/confezione-regalo';

// Prodotti da escludere dal banner
const excludedProducts = ['confezione-regalo'];

// Funzione per andare alla scheda della confezione regalo
function goToGiftProduct() {
  window.location.href = GIFT_PRODUCT_URL;
}

// Inserisce il banner sopra il pulsante Aggiungi al Carrello
document.addEventListener('DOMContentLoaded', () => {
  const addToCartBtn = document.querySelector('form[action^="/cart/add"] button[type="submit"]');
  if (!addToCartBtn) return;

  const currentProductHandle = window.location.pathname.split('/products/')[1];
  if (excludedProducts.includes(currentProductHandle)) return;

  // Crea il banner
  const banner = document.createElement('div');
  banner.textContent = '🎁 Aggiungi la confezione regalo per rendere il tuo regalo ancora più speciale!';
  banner.style.cursor = 'pointer';
  banner.style.backgroundColor = 'white';
  banner.style.border = '1px solid red';
  banner.style.borderRadius = '12px';
  banner.style.padding = '6px 10px';
  banner.style.fontFamily = 'inherit';
  banner.style.fontSize = '14px';
  banner.style.fontWeight = '500';
  banner.style.color = 'red';
  banner.style.textAlign = 'center';
  banner.style.width = addToCartBtn.offsetWidth + 'px';
  banner.style.marginBottom = '8px';
  banner.style.marginTop = '8px';
  banner.addEventListener('click', goToGiftProduct);

  addToCartBtn.parentNode.insertBefore(banner, addToCartBtn);
});
